// DetachModal.jsx
import React from "react";
import { Modal, Button } from "react-bootstrap";
import Image from "react-bootstrap/Image";

const DetachModal = ({ show, handleClose, handleDetach }) => {
  return (
    <Modal show={show} onHide={handleClose} centered className="detach-modal">
      <Modal.Body className="text-center">
        {/* Icon */}
        <Image
          src="/assets/images/detach-main.png"
          alt="detach-icon"
          width={100}
          className="mb-3"
        />

        {/* Text */}
        <p className="mb-4">Are you sure you want to Detach this?</p>

        {/* Buttons */}
        <div className="d-flex justify-content-center gap-3">
          <button variant="none" className="delete-btn w-100" onClick={handleDetach}>
            <img src="/assets/images/detach-icon.svg" alt="deatch" className="me-2" /> Detach
          </button>
          <button variant="none" className="c-b-btn w-100" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DetachModal;
